// extracted by mini-css-extract-plugin
module.exports = {"EntityButton":"EntityButton_EntityButton__Q1q_x","Active":"EntityButton_Active__Odhu6"};